export const lifeExpectancy = [
    [1880,	39.41],
    [1890,	45.209999],
    [1901,	49.299999],
    [1905,	50.299999],
    [1910,	51.799999],
    [1915,	55.099998],
    [1920,	55.400002],
    [1925,	58.5],
    [1930,	59.599998],
    [1935,	60.889999],
    [1940,	63.23],
    [1945,	65.580002],
    [1950,	68.202],
    [1955,	69.263],
    [1960,	69.94],
    [1965,	70.188],
    [1970,	70.777],
    [1975,	72.333],
    [1980,	73.91],
    [1985,	74.662],
    [1990,	75.246],
    [1995,	76.062],
    [2000,	76.812],
    [2005,	77.685],
    [2010,	78.652],
    [2015,	78.91],
    [2019,	78.862],
];